const Input = ({
  label = '',
  rightLabel = null,
  name = '',
  type = 'text',
  className = '',
  inputClassName = '',
  isRequired = true,
  placeholder = '',
  value = '',
  onChange = () => {},
  autoComplete = '',
}) => {
  return (
    <div className="w-full">
      {(label || rightLabel) && (
        <div className="mb-2 flex items-center justify-between">
          {label && (
            <label
              htmlFor={name}
              className="block text-sm font-medium text-slate-700 dark:text-slate-200"
            >
              {label}
            </label>
          )}
          {rightLabel}
        </div>
      )}
      <input
        type={type}
        id={name}
        name={name}
        autoComplete={autoComplete}
        className={`block w-full rounded-xl border border-slate-200 bg-white/80 px-4 py-3 text-sm text-slate-800 shadow-sm transition duration-200 placeholder:text-slate-400 focus:border-violet-500 focus:outline-none focus:ring-4 focus:ring-violet-100 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-violet-400 dark:focus:ring-violet-500/20 ${className} ${inputClassName}`}
        placeholder={placeholder}
        required={isRequired}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Input;
